@if (authorized$ | async) {
  <div class="d-none" ></div>
}
@if (initialized$ | async) {
  <div class="d-none" ></div>
}
